import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {setActiveComp, setActiveLayerIds} from '../formatMovies.slice';
import {RootState} from 'common/src/redux/store';

interface SelectActiveLayerParams {
  compId?: string;
  layerId: string;
}

const selectActiveLayer = createAsyncThunk(
  `${BreadcrumbName.AdBuilder}/selectActiveLayer`,
  async ({compId, layerId}: SelectActiveLayerParams, {dispatch, getState}): Promise<void> => {
    const state = getState() as RootState;
    const isNewImageEditorOpen = state.creativeTemplatePage.formatMovies.isNewImageEditorOpen;

    if (isNewImageEditorOpen) return;

    const targetCompId = compId ?? state.creativeTemplatePage.formatMovies.activeCompId;

    dispatch(setActiveComp(targetCompId));
    dispatch(setActiveLayerIds(layerId ? [layerId] : []));
  },
);

export default selectActiveLayer;
